import { createSlice } from '@reduxjs/toolkit';
import { IRepository } from '../../interface/repositoryInterface';

interface IRepositoryState {
  repositories: IRepository[];
}

const initialState: IRepositoryState = {
  repositories: [],
};

const repositorySlice = createSlice({
  name: 'repository',
  initialState,
  reducers: {
    setRepositories: (state, action) => {
      state.repositories = action.payload;
    },
  },
});

export const { setRepositories } = repositorySlice.actions;
export default repositorySlice.reducer;
